import { render, staticRenderFns } from "./vehicleWiseData.vue?vue&type=template&id=6b1ad5c2&scoped=true&"
var script = {}
import style0 from "./vehicleWiseData.vue?vue&type=style&index=0&id=6b1ad5c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ad5c2",
  null
  
)

export default component.exports